import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { App } from './index'

/**
 * Renders the Application to the DOM
 * @param AppElement
 */
const renderApp = (AppElement: React.ComponentType<any> = App) => {
  const rootEl = document.getElementById('root')
  const renderElement = (
    <AppContainer>
      <AppElement />
    </AppContainer>
  )

  ReactDOM.render(renderElement, rootEl)
}

//Init App
renderApp()

// Hot-reloads components while developing
if (module.hot) {
  module.hot.accept('./index', () => {
    const updatedAppModule = require('./index') as any

    renderApp(updatedAppModule.App)
  })
}



// WEBPACK FOOTER //
// ./src/app/containers/App/entry.tsx